// Deterministic background-of-the-day rotation across the 25 Norwegian
// landscape backgrounds in /public/backgrounds/.

const TOTAL = 25;

function dayOfYear(d = new Date()): number {
  const start = Date.UTC(d.getUTCFullYear(), 0, 0);
  const now = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return Math.floor((now - start) / 86_400_000);
}

export function backgroundOfDay(d = new Date()): string {
  const n = (dayOfYear(d) % TOTAL) + 1;
  return `/backgrounds/bg-${String(n).padStart(2, '0')}.jpg`;
}

export function backgroundForSeed(seed: string): string {
  let h = 0;
  for (const ch of seed) h = ((h << 5) - h + ch.charCodeAt(0)) | 0;
  const n = (Math.abs(h) % TOTAL) + 1;
  return `/backgrounds/bg-${String(n).padStart(2, '0')}.jpg`;
}
